module.exports = __webpack_public_path__ + "img/sec-7_icon-angio.64d7806e.svg";